import { useTranslation } from "react-i18next";
import { Label, Select } from "@tellescope/design-system";
import { cn } from "@tellescope/utils";
import { TIMEZONES, TIMEZONES_USA } from "@tellescope/types-models";
import { TellescopeFormFieldBaseProps } from "../types";
import { FieldDescription } from "../FieldDescription";

export interface TimezoneFieldProps extends TellescopeFormFieldBaseProps<"Timezone"> {
  placeholder?: string;
  wrapperClassName?: string;
  allowInternational?: boolean;
}

export const TimezoneField = ({
  title,
  description,
  htmlDescription,
  placeholder,
  value,
  onChange,
  className,
  error,
  onBlur,
  touched,
  wrapperClassName,
  required,
  allowInternational = true,
  autoFocus,
  disabled,
}: TimezoneFieldProps) => {
  const { t } = useTranslation("forms");
  const showError = !!(error && touched);
  const timezones = allowInternational ? TIMEZONES : TIMEZONES_USA;

  return (
    <div className={cn("space-y-1", wrapperClassName)}>
      <Label required={required}>{title || placeholder || t("Select a timezone")}</Label>
      <FieldDescription description={description} htmlDescription={htmlDescription} />
      <Select
        clearable
        value={value || undefined}
        onValueChange={(selected) => onChange(selected ?? "")}
        disabled={disabled}
      >
        <Select.Trigger
          autoFocus={autoFocus}
          onBlur={onBlur}
          aria-invalid={showError}
          className={cn("w-full", className)}
        >
          <Select.Value placeholder={placeholder || t("Select a timezone")} />
        </Select.Trigger>
        <Select.Content searchable searchPlaceholder={t("Search timezones...")} emptyText={t("No timezone found")}>
          {timezones.map((timezone) => (
            <Select.Item key={timezone} value={timezone}>
              {timezone}
            </Select.Item>
          ))}
        </Select.Content>
      </Select>
      {showError && <p className="text-sm text-destructive mt-1">{error}</p>}
    </div>
  );
};
